module.exports = __webpack_public_path__ + "img/VR.f6b6dea9.png";